import { useNavigate } from 'react-router-dom';
import { Container, Typography } from '@mui/material';
import { EditOutlined, MoreVert, People, DateRange } from '@mui/icons-material';
import { RouteEnum, useGotoRoute } from 'App';
import { MenuItem } from 'shared/types';
import {
  useCourses,
  usePagination,
  usePartner,
  useResponsive,
  ActionMenu,
  IconsNew,
  Loader,
  SimpleList,
  getCreatePath,
  getEditPath,
  getManageUsersPath,
} from '@shared';
import * as S from 'shared/styles/SimpleList.styled';

export const List = ({
  rootPath,
  partner,
  enableSelfService,
}: {
  rootPath: RouteEnum;
  partner: string;
  enableSelfService: boolean;
}) => {
  const isMobile = useResponsive({ query: 'down', key: 'sm' });

  const [page, setPage] = usePagination();
  const { name: partnerName } = usePartner({ partner });
  const navigate = useNavigate();
  const { data, isLoading, isError, isFetching } = useCourses({ partner, page });

  const goToRoute = useGotoRoute(RouteEnum.Exams);

  const settingsItems: MenuItem[] = [
    {
      label: 'Add course',
      icon: DateRange,
      onClick: () => navigate(getCreatePath(rootPath)),
    },
  ];

  if (isLoading) {
    return <Loader />;
  }
  if (isError) {
    return null;
  }

  return (
    <Container component='article'>
      <SimpleList
        title={partnerName}
        subtitle='List of available courses'
        settingsItems={enableSelfService ? settingsItems : undefined}
        rows={data.courses}
        isLoading={isFetching}
        onRowClick={goToRoute}
        entityName={'course'}
        renderElems={({ studentCount, examCount, name, uuid }) => (
          <S.Container isMobile={isMobile}>
            <Typography variant='tableCell'>{name}</Typography>
            <S.Box isMobile={isMobile}>
              <IconsNew
                studentCount={studentCount}
                examCount={examCount}
                titles={['Students', 'Exams']}
              />
              <ActionMenu
                icon={MoreVert}
                items={[
                  {
                    label: 'Edit course',
                    icon: EditOutlined,
                    disabled: !enableSelfService,
                    onClick: () => navigate(getEditPath(rootPath, uuid)),
                  },
                  {
                    label: 'Manage users',
                    icon: People,
                    onClick: () => navigate(getManageUsersPath(rootPath, uuid)),
                  },
                ]}
              />
            </S.Box>
          </S.Container>
        )}
        pagination={data.pagination.totalPages > 1}
        totalPages={data.pagination.totalPages}
        onPageChange={setPage}
      />
    </Container>
  );
};
